export default __webpack_public_path__ + "static/media/pain.0e47e265.jpg";